export default __webpack_public_path__ + "static/playlist-cleaner-snapshot-092d315a2deb064a8eb56507358ebe5d.png";